export const teamMembers = [
  {
    name: "星野 遥",
    role: "内容主编",
    bio: "十年动漫媒体从业者，负责站内资讯与专题的选题策划，偏爱安静治愈系作品。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20stylized%20anime%20portrait%20of%20a%20friendly%20young%20woman%20editor%20with%20short%20dark%20hair%20and%20round%20glasses%2C%20warm%20pink%20studio%20background%2C%20gentle%20lighting%2C%20high%20detail&width=480&height=480&seq=sakura-team-hoshino&orientation=squarish",
  },
  {
    name: "林 深",
    role: "特约评测",
    bio: "写影评也写代码，关注叙事结构与镜头语言，认为好的动画首先是好的故事。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20stylized%20anime%20portrait%20of%20a%20calm%20young%20man%20writer%20with%20messy%20hair%20and%20a%20grey%20hoodie%2C%20warm%20pink%20studio%20background%2C%20gentle%20lighting%2C%20high%20detail&width=480&height=480&seq=sakura-team-linshen&orientation=squarish",
  },
  {
    name: "小满",
    role: "社区运营",
    bio: "负责站内活动与用户互动，收集每一条反馈，努力让社区保持温柔又有活力的氛围。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20stylized%20anime%20portrait%20of%20a%20cheerful%20young%20woman%20community%20manager%20with%20long%20braided%20hair%20and%20a%20pink%20cardigan%2C%20warm%20studio%20background%2C%20gentle%20lighting%2C%20high%20detail&width=480&height=480&seq=sakura-team-xiaoman&orientation=squarish",
  },
  {
    name: "川上",
    role: "视觉设计",
    bio: "负责站内视觉与专题插画，坚信留白和克制的颜色，才撑得住内容的重量。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20stylized%20anime%20portrait%20of%20a%20quiet%20young%20man%20designer%20with%20long%20hair%20tied%20back%20and%20a%20beige%20shirt%2C%20warm%20pink%20studio%20background%2C%20gentle%20lighting%2C%20high%20detail&width=480&height=480&seq=sakura-team-kawakami&orientation=squarish",
  },
];

export const milestones = [
  {
    year: "2019",
    title: "从一个博客开始",
    text: "最初只是三个人维护的番剧推荐博客，每周更新一篇长评，靠读者留言慢慢积累起第一批用户。",
  },
  {
    year: "2021",
    title: "上线动漫资料库",
    text: "整理了两千多部作品的资料与分类标签，第一次让用户可以用「类型 + 年份 + 地区」找到想看的作品。",
  },
  {
    year: "2023",
    title: "资讯频道独立运营",
    text: "组建专职编辑团队，覆盖新番片单、行业观察与深度评测，日均更新内容超过二十篇。",
  },
  {
    year: "2026",
    title: "全新门户版本",
    text: "重构整站结构，加入收藏、筛选与搜索能力，让「找番」这件事变得更快也更舒服。",
  },
];

export const siteStats = [
  { label: "收录作品", value: "2,400+" },
  { label: "累计资讯", value: "18,600+" },
  { label: "注册用户", value: "96万" },
  { label: "日均访问", value: "32万" },
];